/**
 * @file
 * Responsive menu.
 */

var Drupal = Drupal || {};

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.responsiveMenu = {
    attach: function(context) {
      $(window).on('scroll', function () {
        // smaller header on scroll
        if($(document).scrollTop() > 300) {
          $('header.header').addClass('head-not-top');
        } else {
          $('header.header').removeClass('head-not-top');
        }
      });
    }
  };
})(jQuery, Drupal);
